__turbopack_context__.v({
  "activeTab": "ATSKeywords-module__P78SDW__activeTab",
  "certContext": "ATSKeywords-module__P78SDW__certContext",
  "certName": "ATSKeywords-module__P78SDW__certName",
  "certTag": "ATSKeywords-module__P78SDW__certTag",
  "certTags": "ATSKeywords-module__P78SDW__certTags",
  "container": "ATSKeywords-module__P78SDW__container",
  "copiedBadge": "ATSKeywords-module__P78SDW__copiedBadge",
  "copyAllButton": "ATSKeywords-module__P78SDW__copyAllButton",
  "copyButton": "ATSKeywords-module__P78SDW__copyButton",
  "footer": "ATSKeywords-module__P78SDW__footer",
  "formatTipsBox": "ATSKeywords-module__P78SDW__formatTipsBox",
  "formula": "ATSKeywords-module__P78SDW__formula",
  "formulaBox": "ATSKeywords-module__P78SDW__formulaBox",
  "formulaExample": "ATSKeywords-module__P78SDW__formulaExample",
  "formulaItem": "ATSKeywords-module__P78SDW__formulaItem",
  "formulaPlus": "ATSKeywords-module__P78SDW__formulaPlus",
  "groupIntro": "ATSKeywords-module__P78SDW__groupIntro",
  "header": "ATSKeywords-module__P78SDW__header",
  "headerContent": "ATSKeywords-module__P78SDW__headerContent",
  "headerIcon": "ATSKeywords-module__P78SDW__headerIcon",
  "importanceCritical": "ATSKeywords-module__P78SDW__importanceCritical",
  "importanceHigh": "ATSKeywords-module__P78SDW__importanceHigh",
  "importanceMedium": "ATSKeywords-module__P78SDW__importanceMedium",
  "infoBox": "ATSKeywords-module__P78SDW__infoBox",
  "infoIcon": "ATSKeywords-module__P78SDW__infoIcon",
  "keywordGroup": "ATSKeywords-module__P78SDW__keywordGroup",
  "keywordTag": "ATSKeywords-module__P78SDW__keywordTag",
  "keywordTags": "ATSKeywords-module__P78SDW__keywordTags",
  "keywordsSection": "ATSKeywords-module__P78SDW__keywordsSection",
  "legend": "ATSKeywords-module__P78SDW__legend",
  "placementAdvice": "ATSKeywords-module__P78SDW__placementAdvice",
  "placementBox": "ATSKeywords-module__P78SDW__placementBox",
  "placementGrid": "ATSKeywords-module__P78SDW__placementGrid",
  "placementItem": "ATSKeywords-module__P78SDW__placementItem",
  "placementLocation": "ATSKeywords-module__P78SDW__placementLocation",
  "sampleArrow": "ATSKeywords-module__P78SDW__sampleArrow",
  "sampleCard": "ATSKeywords-module__P78SDW__sampleCard",
  "sampleComparison": "ATSKeywords-module__P78SDW__sampleComparison",
  "sampleExplanation": "ATSKeywords-module__P78SDW__sampleExplanation",
  "sampleLabel": "ATSKeywords-module__P78SDW__sampleLabel",
  "samplesSection": "ATSKeywords-module__P78SDW__samplesSection",
  "sectionIntro": "ATSKeywords-module__P78SDW__sectionIntro",
  "strongExample": "ATSKeywords-module__P78SDW__strongExample",
  "tab": "ATSKeywords-module__P78SDW__tab",
  "tabIcon": "ATSKeywords-module__P78SDW__tabIcon",
  "tabLabel": "ATSKeywords-module__P78SDW__tabLabel",
  "tabNav": "ATSKeywords-module__P78SDW__tabNav",
  "tipCard": "ATSKeywords-module__P78SDW__tipCard",
  "tipSection": "ATSKeywords-module__P78SDW__tipSection",
  "tipText": "ATSKeywords-module__P78SDW__tipText",
  "tipsList": "ATSKeywords-module__P78SDW__tipsList",
  "tipsSection": "ATSKeywords-module__P78SDW__tipsSection",
  "verbTag": "ATSKeywords-module__P78SDW__verbTag",
  "verbTags": "ATSKeywords-module__P78SDW__verbTags",
  "weakExample": "ATSKeywords-module__P78SDW__weakExample",
  "whyLabel": "ATSKeywords-module__P78SDW__whyLabel",
});
